module.exports = "https://img.zhijierongxing.com/saas/img/rmb_icon2.3f492223.png";